import { Container } from "@mantine/core";
import { pageMaxWidth, pagePaddingX } from "../../constant/Responsive";

export default function PageContainer({ children, ...props }) {
  return (
    <Container maw={pageMaxWidth} mx="auto" px={pagePaddingX} w="100%" {...props}>
      {children}
    </Container>
  );
}
